// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import Accounting from 'accounting'
import 'raf.js'

import 'common/css/index.styl'

// components
import App from './App'
import Borrow from 'components/borrow/borrow'
import City from 'components/borrow/city'
import BorrowDetail from 'components/borrow/detail'
import Explain from 'components/borrow/explain'
import Discover from 'components/discover/discover'
import Calculator from 'components/discover/calculator-new'
import Instructions from 'components/discover/instructions'
import Process from 'components/discover/process'
import Follow from 'components/discover/follow'
import User from 'components/user/user'
import Settings from 'components/user/settings'
import OrderInfo from 'components/user/order-info'
import OrderProcess from 'components/user/order-process'
import OrderDetail from 'components/user/order-detail'
import Authorization from 'components/user/authorization'
import Repaymentplan from 'components/user/repaymentplan'
import Action from 'components/user/action'
import ProfileSwitch from 'components/user/profile-switch'
import Sign from 'components/user/sign'
import SignProtocol from 'components/user/protocol'
import Login from 'components//sign/login'
import Register from 'components/sign/register'
import Reset from 'components/sign/reset'
import AuthProtocol from 'components/sign/protocol'
import Authentication from 'components/sign/authentication'
import Unbind from 'components/wechat/unbind'
import Forward from 'components/wechat/forward'
import About from 'components/about/about'
import Culture from 'components/about/culture'
import Perspective from 'components/about/perspective'
import AboutArticle from 'components/about/article'
import Consultant from 'components/consultant/consultant'
import ConsultantArticleList from 'components/consultant/article-list'
import ConsultantArticle from 'components/consultant/article'
import Appointment from 'components/consultant/appointment'

import setWechatTitle from './utils/setWechatTitle.js'
// mixins
import Mixin from './mixins'

// plugins
import Browser from './plugins/browser'
import Device from './plugins/device'
import Dialog from './plugins/dialog'
import Ajax from './plugins/ajax'
import AppFrom from './plugins/appfrom'
import VueTouch from 'vue-touch'
Vue.use(VueRouter)
Vue.use(VueResource)

Vue.use(VueTouch, {name: 'touch'})
Vue.use(Mixin)

Vue.use(Browser)
Vue.use(Device)
Vue.use(Dialog)
Vue.use(Ajax)
Vue.use(AppFrom)

if (!Vue.device.isMobile) {
  window.location.href = '//www.91weijia.com/'
}

Vue.http.options.emulateJSON = true
Vue.http.options.emulateHTTP = true

// route map
const routes = [
  {
    path: '/',
    component: App,
    children: [
      {path: '/borrow', component: Borrow, meta: {title: '融资专家'}},
      {path: '/discover', component: Discover, meta: {title: '发现'}},
      {path: '/user', component: User, meta: {title: '我的'}}
    ]
  }, {
    path: '/borrow/city',
    component: City,
    meta: {title: '选择城市'}
  }, {
    path: '/borrow/explain',
    component: Explain,
    meta: {title: '产品列表'}
  }, {
    path: '/borrow/detail/:id',
    component: BorrowDetail,
    meta: {title: '产品详情'}
  }, {
    path: '/borrow/action/:id',
    component: Action,
    meta: {title: '申请借款'}
  }, {
    path: '/auth/login',
    component: Login,
    meta: {title: '登录'}
  }, {
    path: '/auth/register',
    component: Register,
    meta: {title: '注册'}
  }, {
    path: '/auth/protocol',
    component: AuthProtocol,
    meta: {title: '注册协议'}
  }, {
    path: '/auth/authentication',
    component: Authentication,
    meta: {title: '实名认证'}
  }, {
    path: '/auth/reset',
    component: Reset,
    meta: {title: '找回密码'}
  }, {
    path: '/discover/follow',
    component: Follow,
    meta: {title: '关注微信'}
  }, {
    path: '/discover/calc',
    component: Calculator,
    meta: {title: '贷款计算器'}
  }, {
    path: '/discover/instructions',
    component: Instructions,
    meta: {title: '办理房屋抵押须知'}
  }, {
    path: '/discover/process',
    component: Process,
    meta: {title: '借款办理流程'}
  }, {
    path: '/user/settings',
    component: Settings,
    meta: {title: '设置'}
  }, {
    path: '/user/order/:orderNo',
    component: OrderInfo,
    meta: {title: '我的借款'},
    children: [{
      path: '/user/order/:orderNo/detail',
      component: OrderDetail
    }, {
      path: '/user/order/:orderNo/process',
      component: OrderProcess
    }]
  }, {
    path: '/user/order/:orderNo/authorization',
    component: Authorization,
    meta: {
      title: '授权绑定'
    }
  }, {
    path: '/user/order/:orderNo/repaymentplan',
    component: Repaymentplan,
    meta: {
      title: '还款计划'
    }
  }, {
    path: '/user/profile/:type',
    component: ProfileSwitch,
    meta: {title: '完善个人信息'}
  }, {
    path: '/user/sign/:id',
    component: Sign,
    meta: {title: '签约'}
  }, {
    path: '/user/protocol/:id',
    component: SignProtocol,
    meta: {title: '协议'}
  }, {
    path: '/user/unbind',
    component: Unbind,
    meta: {title: '用户解绑'}
  }, {
    path: '/wechat/forward',
    component: Forward,
    meta: {title: '用户绑定'}
  }, {
    path: '/about',
    component: About,
    meta: {title: '关于我们'}
  }, {
    path: '/culture',
    component: Culture,
    meta: {title: '企业文化'}
  }, {
    path: '/culture/article/:id',
    component: AboutArticle,
    meta: {title: '企业文化'}
  }, {
    path: '/perspective',
    component: Perspective,
    meta: {title: '伟嘉视角'}
  }, {
    path: '/perspective/article/:id',
    component: AboutArticle,
    meta: {title: '案例分享'}
  }, {
    path: '/consultant',
    component: Consultant,
    meta: {title: '贷款顾问'}
  }, {
    path: '/consultant/articlelist/:uid',
    component: ConsultantArticleList,
    meta: {title: '贷款顾问个人详情'}
  }, {
    path: '/consultant/article/:uid',
    component: ConsultantArticle,
    meta: {title: '案例分享'}
  },
  {
    path: '/consultant/appointment',
    component: Appointment,
    meta: {title: '立即预约'}
  }
]
const router = new VueRouter({
  linkActiveClass: 'active',
  routes
})

// 登录拦截
router.beforeEach((to, from, next) => {
  let token = Vue.cache.getUserToken()
  if (/user|authentication|reset/.test(to.path) && !token) {
    next('/auth/login')
  }
  next()
})

// 动态设置title
router.afterEach((route) => {
  let title = route.meta.title
  setWechatTitle(title)
})

// filters
Vue.filter('currency', (v, prefix = '', length = 2) => { // 格式化货币
  return Accounting.formatMoney(v, prefix, length)
})
Vue.filter('number', (v, length = 2, sperator = ',') => { // 格式化数字
  return Accounting.formatNumber(v, length, sperator)
})
Vue.filter('unformat', (v) => { // 货币格式变为数字
  return Accounting.unformat(v)
})
Vue.filter('tofixed', (v, length = 2) => { // 将数字保留几位小数
  return Accounting.toFixed(v, length)
})

/* eslint-disable no-new */
new Vue({
  router,
  created () {
    let vm = this
    this.device()
    if (!(/register|login/.test(this.$route.path) && this.$route.query.backurl)) {
      // 不是登录或者注册页面并且没有backurl的
      this.$ajax({
        url: '/getVersion.jhtml',
        done (d) {
          vm.compareVersion(d + '')
        }
      })
    }
  },
  methods: {
    device () {
      // 判断访问来源0：普通浏览器（非微信） 1：内部公众号 2：外部公众号
      let identity = '0' // 默认不是微信
      if (this.$device.isWechat) {
        // 如果是微信
        identity = this.$parseParams(window.location.search).from || '2'
      }
      let cacheDataObj = this.$parseParams(this.$cache.getCache()) || {}
      this.$cache.cache(this.$stringify(Object.assign({}, cacheDataObj, {identity})))
    },
    compareVersion (payload) {
      let version = this.$cache.get('version')
      if (payload && (version - payload < 0)) {
        this.$cache.put('version', payload)
        let search = window.location.search
        let hash = window.location.hash.replace(/v=\d+/, '')
        let patch = (u) => {
          return /\?$/.test(u) ? '' : /\?/.test(u) ? '&' : '?'
        }
        window.location.href = '/' + search + hash + patch(hash) + 'v=' + payload
      }
    }
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js